<template>
	<div>
		<div class="coor-partner" :class="{'coor-partner-white':type==2}">
			<div class="coor-child">
				
				<ul>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part1.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part2.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part3.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part4.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part1.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part2.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part3.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part4.png" /></li>
				</ul>
				<ul>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part1.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part2.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part3.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part4.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part1.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part2.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part3.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part4.png" /></li>
				</ul>
			</div>
		</div>
		<div class="coor-partner" :class="{'coor-partner-white':type==2}">
			<div class="coor-child">
				
				<ul>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part5.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part6.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part7.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part8.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part5.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part6.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part7.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part8.png" /></li>
				</ul>
				<ul>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part5.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part6.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part7.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part8.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0s"><img src="@/assets/img/home/coor-part5.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.2s"><img src="@/assets/img/home/coor-part6.png" /></li>
					<li class="wow fadeInDown" data-wow-duration="1.3s" data-wow-delay="0.3s"><img src="@/assets/img/home/coor-part7.png" /></li>
					<li class="wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.4s"><img src="@/assets/img/home/coor-part8.png" /></li>
				</ul>
			</div>
		</div>
	</div>
	
</template>

<script>
	export default{
		props:['type'],
		data(){
			return {
				
			}
		},
		mounted() {
			
		},
		methods:{
			
		}
	}
</script>

<style scoped>
	.coor-partner{
		width: 100%;
		height: 120px;
		position: relative;
		overflow: hidden;
	}
	.coor-partner::before{
		background-image: -webkit-linear-gradient(left,#F6F8FA 20%,rgba(235,237,240,0));
		content: "";
		height: 120%;
		left: -15px;
		position: absolute;
		top: -10px;
		width: 100px;
		z-index: 2;
	}
	.coor-partner::after{
		background-image: -webkit-linear-gradient(right,#F6F8FA 20%,rgba(235,237,240,0));
		content: "";
		height: 120%;
		position: absolute;
		right: -15px;
		top: -10px;
		width: 100px;
		z-index: 2;
	}
	.coor-partner-white::before{
		background-image: -webkit-linear-gradient(left,#fff 20%,rgba(235,237,240,0));
	}
	.coor-partner-white::after{
		background-image: -webkit-linear-gradient(right,#fff 20%,rgba(235,237,240,0));
	}
	.coor-child{
		display: flex;
	}
	.coor-partner ul{
		/* width: 100%; */
		height: 120px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 0;
		margin: 0;
		
		display: flex;
		animation-duration: 60s;
		animation: CasePlay--move--zgwQAZu 30s linear infinite;
	}
	.coor-partner:nth-child(2) ul{
		animation-duration: 80s;
		animation: CasePlay--move--zgwQAZu 50s linear infinite;
	}
	.coor-child:hover ul{
		animation-play-state: paused;
		-moz-animation-play-state: paused;
		-webkit-animation-play-state: paused;
	}
	
	@-webkit-keyframes CasePlay--move--zgwQAZu {
	 0% {
	  -webkit-transform:translate(0);
	  transform:translate(0)
	 }
	 to {
	  -webkit-transform:translate(-100%);
	  transform:translate(-100%)
	 }
	}
	@-moz-keyframes CasePlay--move--zgwQAZu {
	 0% {
	  -moz-transform:translate(0);
	  transform:translate(0)
	 }
	 to {
	  -moz-transform:translate(-100%);
	  transform:translate(-100%)
	 }
	}
	@keyframes CasePlay--move--zgwQAZu {
	 0% {
	  -webkit-transform:translate(0);
	  -moz-transform:translate(0);
	  transform:translate(0)
	 }
	 to {
	  -webkit-transform:translate(-100%);
	  -moz-transform:translate(-100%);
	  transform:translate(-100%)
	 }
	}
	.coor-partner ul li{
		width: 278px;
		height: 100px;
		margin: 0 15px;
		background: #FFFFFF;
		box-shadow: 0px 0px 18px 0px rgba(230,230,230,0.42);
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.coor-partner ul li:hover{
		box-shadow: 0px 0px 18px 0px rgba(230,230,230,0.9);
	}
	.coor-partner ul li img{
		width: 180px;
		height: 65px;
	}
</style>
<style scoped>
	@media only screen and (min-width:992px) and (max-width:1199px) {
		
	}
	
	@media only screen and (min-width:768px) and (max-width:991px) {
		
	}
	@media (max-width:767px) {
		.coor-partner{
			height: 80px;
		}
		.coor-partner ul{
			height: 80px;
		}
		.coor-partner ul li{
			width: 165px;
			height: 60px;
		}
		.coor-partner ul li img{
			width: 110px;
			height: auto;
		}
		.coor-partner::before{
			width: 0px;
		}
		.coor-partner::after{
			width: 0px;
		}
	}
</style>



